<canvas #doughnutCanvas style="width: 100%; height: 400px;"></canvas>
